var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('LoadingBox',{ref:"LoadingBox"}),_c('ConfirmBox',{ref:"ConfirmBox"}),_c('ConnectWalletBox',{ref:"ConnectWalletBox"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }